module.exports = meta-touch;


//////////////////
// WEBPACK FOOTER
// external "meta-touch"
// module id = 2897
// module chunks = 0